export default __webpack_public_path__ + "static/green-a2aef42869187cc9a189fa9e988abb85.png";